<template>
  <div class="mall-nav-wrap">
    <FixedRightBar v-if="!isErpBuySite && config.showDefaultRightBar !== false" />

    <div class="searchContainer">
      <a v-if="!isErpBuySite" :href="`/`">
        <img
          v-if="showLogoImage"
          class="logo-item"
          :src="config.imgURL"
          :alt="brandName"
          :style="logoStyle"
          loading="eager"
          fetchpriority="high"
          decoding="async"
          referrerpolicy="no-referrer"
        />
      </a>

      <div v-if="isErpBuySite" class="erp-buy-toolbar-wrap">
        <NuxtLink class="erp-buy-toolbar-icon-box" :to="userCenterHomePath">
          <div class="container">
            <LazyImage
              class="normal-icon"
              src="/assets/imgs/user.png"
              :use-lazy="false"
              :tint-color="toolbarIconTintColor"
            />
            <div class="info-text">{{ $t("texts.userCenter") }}</div>
          </div>
        </NuxtLink>
        <NuxtLink class="erp-buy-toolbar-icon-box" :to="mallCartPath" @click="rememberWdCartTabIfNeeded">
          <div class="container">
            <LazyImage
              class="normal-icon"
              src="/assets/imgs/cart.png"
              :use-lazy="false"
              :tint-color="toolbarIconTintColor"
            />
            <div class="info-text">{{ $t("texts.buyCart") }}</div>
          </div>
        </NuxtLink>
        <NuxtLink class="erp-buy-toolbar-icon-box" :to="userCenterOrdersPath">
          <div class="container">
            <LazyImage
              class="normal-icon"
              src="/assets/imgs/order.png"
              :use-lazy="false"
              :tint-color="toolbarIconTintColor"
            />
            <div class="info-text">{{ $t("texts.orderCenter") }}</div>
          </div>
        </NuxtLink>
      </div>

      <div class="search-input-wrap">
        <el-popover
          placement="bottom-start"
          title
          popper-class="search-menu-popper-wrap"
          :offset="0"
          :width="675"
          trigger="click"
        >
          <SearchNavTree />
          <template #reference>
            <el-input
              v-model="keywordProxy"
              clearable
              :placeholder="$t('placeholder.keywordAny1688AndStoreLink')"
              class="search-input-component"
              @keyup.enter="onKeywordSearch"
            >
              <template #prepend>
                <el-select
                  size="large"
                  class="search-type"
                  v-model="searchTypeProxy"
                  @click.stop="() => {}"
                  placeholder
                >
                  <el-option label="1688" value="1" />
                  <el-option :label="$t('texts.tbAndTmall')" value="2" />
                </el-select>
              </template>
              <template #append>
                <el-button class="search-btn" :icon="Search" @click="onKeywordSearch" />
              </template>
            </el-input>
          </template>
        </el-popover>
      </div>
      <el-button @click="openImgSearch" class="img-search-btn" type="info" :icon="Camera">
        {{ $t("actions.imageSearch") }}
      </el-button>

      <div v-show="!isErpBuySite">
        <LocaleCurrencyChange :theme-vars="themeVars" />
      </div>
      <RightNavItems
        v-if="!isErpBuySite"
        class="mall-right-nav-list"
        :items="config.rightNavigationList || []"
        :get-locale-text="getLocaleText"
        item-class="mall-right-nav-item"
        :theme-vars="themeVars"
      />
      <div class="ml-30px" v-if="isErpBuySite"></div>
      <MallAccountEntry
        v-if="!isErpBuySite"
        class="user-info-wrap"
        :mall-user-info="mallUserInfo"
        :logout="logout"
        variant="default"
        :theme-vars="themeVars"
      />
    </div>

    <div v-if="!isErpBuySite">
      <div class="navigation-item-box">
        <el-popover
          placement="bottom-start"
          title
          popper-class="category-menu-popper-wrap"
          :offset="0"
          :width="250"
          trigger="hover"
        >
          <CategoryMenu />
          <template #reference>
            <div class="category-btn-wrap">
              <el-icon>
                <Menu />
              </el-icon>
              <span class="category-btn-text">{{ $t("texts.category") }}</span>
            </div>
          </template>
        </el-popover>

        <div class="navigation-item" v-for="(item, index) in normalizedNavigationList" :key="index">
          <a
            v-if="item.linkUrl === '/'"
            :class="{
              'navigation-item-title': true,
              'navigation-item-title-active': actionIndex === index,
              ['navigation-item-title-' + index]: true,
            }"
            :style="{
              fontSize: (config.textConfigs?.fontSize ?? 18) + 'px',
              fontWeight: config.textConfigs?.fontWeight ?? 'normal',
              color:
                actionIndex === index
                  ? (config.textConfigs?.fontActionColor ?? themeVars?.navActiveTextColor ?? '#346bd2')
                  : (config.textConfigs?.fontColor ?? themeVars?.navTextColor ?? '#333'),
            }"
            href="/"
            @click="trackNavigationItem(item, index)"
          >
            <LazyImage
              v-if="item.linkIcon"
              class="navigation-item-icon"
              :src="item.linkIcon"
              :use-lazy="false"
              :tint-color="getNavigationIconTintColor(item, index)"
            />
            {{ getLocaleText(item.title) }}
          </a>
          <NuxtLink
            v-else
            :class="{
              'navigation-item-title': true,
              'navigation-item-title-active': actionIndex === index,
              ['navigation-item-title-' + index]: true,
            }"
            :style="{
              fontSize: (config.textConfigs?.fontSize ?? 18) + 'px',
              fontWeight: config.textConfigs?.fontWeight ?? 'normal',
              color:
                actionIndex === index
                  ? (config.textConfigs?.fontActionColor ?? themeVars?.navActiveTextColor ?? '#346bd2')
                  : (config.textConfigs?.fontColor ?? themeVars?.navTextColor ?? '#333'),
            }"
            :to="item.linkUrl"
            :target="getJumpType?getJumpType(item, true):undefined"
            @click="trackNavigationItem(item, index)"
          >
            <LazyImage
              v-if="item.linkIcon"
              class="navigation-item-icon"
              :src="item.linkIcon"
              :use-lazy="false"
              :tint-color="getNavigationIconTintColor(item, index)"
            />
            {{ getLocaleText(item.title) }}
          </NuxtLink>
        </div>
      </div>
    </div>

    <div class="NavigationBar-slot" v-html="config.htmlText"></div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "#app";
import { Menu, Search, Camera } from "@element-plus/icons-vue";
import LazyImage from "@/components/common/LazyImage/index.vue";
import CategoryMenu from "./CategoryMenu.vue";
import SearchNavTree from "./SearchNavTree.vue";
import FixedRightBar from "./FixedRightBar.vue";
import LocaleCurrencyChange from "./LocaleCurrencyChange.vue";
import RightNavItems from "./RightNavItems.vue";
import MallAccountEntry from "./MallAccountEntry.vue";
import { $t } from "~/utils/index.js";
import { legacyPathToUserCenterPath } from "~/user-center/routes";
import { trackLowCodeEvent } from "@/utils/lowCodeTracking.js";

const props = defineProps({
  config: { type: Object, default: () => ({}) },
  themeVars: { type: Object, default: () => ({}) },
  isErpBuySite: { type: Boolean, default: false },
  showNavigationList: { type: Array, default: () => [] },
  actionIndex: { type: Number, default: 0 },
  mallUserInfo: { type: Object, default: () => ({}) },
  searchKeyword: { type: String, default: "" },
  searchType: { type: String, default: "1" },
  getLocaleText: { type: Function, required: true },
  getJumpType: { type: Function, required: true },
  onKeywordSearch: { type: Function, required: true },
  openImgSearch: { type: Function, required: true },
  logout: { type: Function, required: true },
});

const emit = defineEmits(["update:searchKeyword", "update:searchType"]);
const route = useRoute();
const ERP_MALL_CART_TAB_KEY = "erp_mall_cart_default_tab";
const userCenterHomePath = legacyPathToUserCenterPath("/mall/home");
const userCenterOrdersPath = legacyPathToUserCenterPath("/mall/platformAllOrderListV2");
const normalizedNavigationList = computed(() => {
  return (props.showNavigationList || []).map(item => ({
    ...item,
    linkUrl: legacyPathToUserCenterPath(String(item?.linkUrl || "")),
  }));
});
const brandName = computed(() => {
  return String(
    props.config?.logoText
    || props.mallUserInfo?.siteName
    || props.mallUserInfo?.realName
    || "Mall"
  ).trim();
});
const showLogoImage = computed(() => Boolean(String(props.config?.imgURL || "").trim()));
const logoStyle = computed(() => {
  const w = Number(props.config?.imgWidth) || 160;
  const h = Number(props.config?.imgHeight) || 44;
  return {
    width: `${w}px`,
    height: `${h}px`,
    minWidth: `${w}px`,
    minHeight: `${h}px`,
    objectFit: props.config?.fit || "contain",
    display: "block",
  };
});

const mallCartPath = computed(() => {
  const currentPath = String(route.path || "");
  return legacyPathToUserCenterPath(currentPath.startsWith("/wd") ? "/mall/cart?tab=wd" : "/mall/cart");
});

function rememberWdCartTabIfNeeded() {
  if (!process.client) return;
  const currentPath = String(route.path || "");
  if (currentPath.startsWith("/wd")) {
    window.localStorage.setItem(ERP_MALL_CART_TAB_KEY, "wd");
  }
}

function trackNavigationItem(item, index) {
  trackLowCodeEvent(item?.trackingConfig, {
    trigger: "click",
    element: item,
    elementType: "navigation_item",
    elementIndex: index,
    page: { fullPath: route.fullPath, path: route.path },
  });
}

const keywordProxy = computed({
  get: () => props.searchKeyword,
  set: (v) => emit("update:searchKeyword", v ?? ""),
});

const searchTypeProxy = computed({
  get: () => props.searchType,
  set: (v) => emit("update:searchType", v ?? "1"),
});

const navBackgroundColor = computed(
  () => props.themeVars?.navBackgroundColor || props.config?.backgroundColor || "#ffffff"
);
const navTextColor = computed(
  () => props.themeVars?.navTextColor || props.config?.textConfigs?.fontColor || "#333333"
);
const navActiveTextColor = computed(
  () =>
    props.config?.textConfigs?.fontActionColor
    || props.themeVars?.navActiveTextColor
    || "#346bd2"
);
const navSearchAccent = computed(() => props.themeVars?.navSearchAccent || "#b4272b");
const navInputBackground = computed(() => props.themeVars?.navInputBackground || "#ffffff");
const navInputTextColor = computed(() => props.themeVars?.navInputTextColor || "#000000");
const navInputPlaceholderColor = computed(
  () => props.themeVars?.navInputPlaceholderColor || "#999999"
);
const navPrimaryButtonTextColor = computed(
  () => props.themeVars?.navPrimaryButtonTextColor || "#ffffff"
);
const navPanelBackground = computed(() => props.themeVars?.navPanelBackground || "#f6f6f6");
const navBorderColor = computed(() => props.themeVars?.navBorderColor || "transparent");
const navDividerColor = computed(() => props.themeVars?.navDividerColor || "#dfdfdf");
const toolbarIconTintColor = computed(() => {
  return props.themeVars?.navTextColor || "";
});

function getNavigationIconTintColor(item, index) {
  if (!item?.linkIcon) {
    return "";
  }
  const isActive = props.actionIndex === index;
  if (isActive) {
    return item?.iconActiveTintColor || item?.iconTintColor || "";
  }
  return item?.iconTintColor || "";
}
</script>

<style scoped lang="less">
.mall-nav-wrap {
  flex: 1;
  width: 100%;
  background-color: v-bind("navBackgroundColor");
  color: v-bind("navTextColor");
}
.searchContainer {
  display: flex;
  align-items: center;
  padding: 23px 0;
}
.search-type {
  margin: 0px !important;
}
.search-input-wrap {
  flex: 1;
  margin: 0 18px 0 36px;
  height: 50px;
  overflow: hidden;
  border-radius: 4px;
  border: 2px solid v-bind("navSearchAccent");
  background-color: v-bind("navInputBackground");
  :deep(.el-select__wrapper) {
    border: none;
    background-color: transparent;
  }
  .search-input-component {
    height: 100%;

    :deep(.el-input__wrapper) {
      box-shadow: none;
      border: none;
      background-color: transparent;
      &::before {
        content: " ";
        position: absolute;
        left: 0px;
        top: 50%;
        height: 16px;
        margin-top: -8px;
        width: 1px;
        background-color: v-bind("navDividerColor");
      }

      .el-input__inner {
        border: none;
        font-size: 14px;
        font-weight: 500;
        color: v-bind("navInputTextColor");
      }
    }
  }
  :deep(.el-input__inner::placeholder) {
    color: v-bind("navInputPlaceholderColor");
  }
  :deep(.el-input-group__append) {
    padding: 0px;
    background: none;
    box-shadow: none;
    width: 64px;
    .search-btn {
      background-color: v-bind("navSearchAccent");
      color: v-bind("navPrimaryButtonTextColor");
      font-size: 26px;
      width: 64px;
      height: 54px;
      border-radius: 0;
      display: flex;
      align-items: center;
    }
  }
  :deep(.el-input-group__prepend) {
    padding: 0px;
    width: 128px;
    background: none;
    box-shadow: none;
    .el-select__wrapper {
      box-shadow: none !important;
    }
    .el-input__inner,
    .el-select__placeholder {
      color: v-bind("navInputTextColor");

      font-size: 18px !important;
      font-weight: 400 !important;
    }
  }
}
.img-search-btn {
  min-width: 120px;
  height: 54px;
  background: v-bind("navPanelBackground");
  color: v-bind("navTextColor");
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  border: 1px solid v-bind("navBorderColor");
  :deep(.el-icon) {
    font-size: 20px;
  }
}
.user-info-wrap {
  margin-left: 6px;
  display: flex;
  align-items: center;
  .avatar-link {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    text-decoration: none;
  }
  .user-info-box {
    width: 180px;
    margin-left: 12px;
    .user-link {
      font-size: 16px;
      color: #333;
      text-decoration: underline;
      font-weight: 400;
      display: inline-block;
      white-space: nowrap;
    }
  }
}
.mall-right-nav-list {
  margin-left: 10px;
}
.mall-right-nav-list :deep(.mall-right-nav-item) {
  font-size: 16px;
  color: v-bind("navTextColor");
  font-weight: 500;
}
.mall-right-nav-list :deep(.mall-right-nav-item__icon) {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.navigation-item-box {
  display: flex;
  height: 50px;
  .category-btn-wrap {
    width: 240px;
    height: 50px;
    background-color: v-bind("navSearchAccent");
    display: flex;
    align-items: center;
    color: v-bind("navPrimaryButtonTextColor");
    padding-left: 12px;
    margin-right: 15px;
    cursor: pointer;
    :deep(.el-icon) {
      font-size: 20px;
    }
    .category-btn-text {
      font-weight: 700;
      font-size: 16px;
      color: v-bind("navPrimaryButtonTextColor");
      margin-left: 6px;
    }
  }
  .navigation-item {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 155px;
    position: relative;
    padding: 10px;
    max-width: 200px;
    line-height: 1.1;
    &:last-child {
      &::after {
        display: none;
      }
    }
    &::after {
      content: " ";
      position: absolute;
      background-color: v-bind("navDividerColor");
      height: 17px;
      width: 1px;
      right: 0px;
      top: 50%;
      margin-top: -8.5px;
    }
    .navigation-item-title {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      text-decoration: none;
      color: v-bind("navTextColor");
      font-weight: 400;
      font-size: 16px;
    }
    .navigation-item-title-active {
      color: v-bind("navActiveTextColor") !important;
    }
  }
}
.erp-buy-toolbar-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 -20px 0 20px;

  .erp-buy-toolbar-icon-box > .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0px 2px;
    min-width: 50px;
    .normal-icon {
      height: 25px;
      width: 25px;
    }
    .info-text {
      font-size: 12px;
      margin: 5px 0 0;
      white-space: nowrap;
      color: v-bind("navTextColor");
    }
  }
}

.navigation-item-icon {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
}
</style>

<style lang="less">
.category-menu-popper-wrap {
  min-width: 252px !important;

  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  .el-popper__arrow {
    display: none;
  }
  padding: 0 !important;
  margin-top: 0 !important;
}
.search-menu-popper-wrap {
  min-width: 675px !important;

  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  .el-popper__arrow {
    display: none;
  }

  margin-top: 0 !important;
}
</style>
